import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserResponse {
  message: string;
  id: string;
  user_id: string;
};

// 请求接口
export interface AddAgentUsersRequest {
  agentId: string;
  email: string;
  userName: string;
  roleType: number;
  userManagement?: number;
  permissionManagement?: number;
  dataOverviewManagement?: number;
  contentManagement?: number;
  orderManagement?: number;
  companyManagement?: number;
}


export class AddAgentUserData {
  @IsNumber("Id must be a number")
  id: number;

  @IsString("Message must be a string")
  message: string;

  @IsString("User ID must be a string")
  userId: string;
}

const transformAndValidateAgent = (
  response: AgentUserResponse
): AddAgentUserData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AddAgentUserData);
  } catch (error) {
    console.error("Agent User data validation failed:", error.message);
    throw error;
  }
};

/** 添加管理员 */
export const addAgentUserAdmin = async ({
  agentId,
  email,
  userName,
  roleType,
  userManagement,
  permissionManagement,
  dataOverviewManagement,
  contentManagement,
  orderManagement,
  companyManagement,
}: AddAgentUsersRequest): Promise<AddAgentUserData> => {
  const response = await api.post<AgentUserResponse>('/agent-v2/add-agent-user', {
    agent_id: agentId,
    user_name: userName,
    role_type: roleType,
    email: email,
    user_management: userManagement,
    permission_management: permissionManagement,
    data_overview_management: dataOverviewManagement,
    content_management: contentManagement,
    order_management: orderManagement,
    company_management: companyManagement,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
